import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import CopyAssignmentLink from "@/view/ShareAssignmentModal/ShareAssignmentModalButtons/CopyAssignmentLink";
import PrintAssignment from "@/view/ShareAssignmentModal/ShareAssignmentModalButtons/PrintAssignment";
import ViewAllAssignments from "@/view/ShareAssignmentModal/ShareAssignmentModalButtons/ViewAllAssignments";
import {
  shareCtaContainerCss,
  shareCtaDividerCss,
  shareCtaPrintAssignmentCss,
} from "./ShareAssignmentModalContent.style";

const propTypes = {
  allAssignmentsLink: PropTypes.string,
  assignmentLink: PropTypes.string,
  contentId: PropTypes.string,
  isPrintDisabled: PropTypes.bool,
  printLink: PropTypes.string,
  streamProperties: PropTypes.object,
};

const ShareAssignmentModalContent = ({
  allAssignmentsLink,
  assignmentLink,
  contentId,
  isPrintDisabled,
  printLink,
  streamProperties,
}) => {
  return (
    <div css={shareCtaContainerCss}>
      <CopyAssignmentLink
        assignmentLink={assignmentLink}
        contentId={contentId}
        streamProperties={streamProperties}
      />

      <div css={shareCtaDividerCss}>OR</div>

      <PrintAssignment
        __cssFor={shareCtaPrintAssignmentCss}
        flavor={Button.flavors.muted}
        isPrintDisabled={isPrintDisabled}
        printLink={printLink}
        streamProperties={streamProperties}
      >
        Print this assignment
      </PrintAssignment>

      <ViewAllAssignments
        allAssignmentsLink={allAssignmentsLink}
        streamProperties={streamProperties}
      />
    </div>
  );
};

ShareAssignmentModalContent.propTypes = propTypes;

export default ShareAssignmentModalContent;
